import { ToggleText } from 'common-front/src/designSystem/components/toggle';
import { styled } from 'common/src/designSystem/components/stitches';
import { PositionPermission } from 'common/src/graphql/permissions/dsl';
import * as React from 'react';

const Group = styled('div', {
    display: 'grid',
    gap: '$4 $7',
    gridTemplateColumns: '280px auto'
});

const Label = styled('div', { fontWeight: '$medium', gridColumn: 1 });

type ToggleProps = {
    children: React.ReactNode;
    disabled?: boolean;
    permission: PositionPermission;
    subtext?: string;
    value: string;
    onChange: (value: string) => void;
};

const Toggle = ({ children, disabled, permission, subtext, value, onChange }: ToggleProps) => (
    <div style={{ gridColumn: 2 }}>
        <ToggleText
            css={{
                alignItems: 'start',
                '> *:first-child': {
                    margin: '2px 0' /* Align toggle to the first line of the label. */
                }
            }}
            disabled={disabled}
            subtext={subtext}
            value={value[permission] === '1'}
            onChange={(toggled) =>
                onChange([...value].toSpliced(permission, 1, toggled ? '1' : '0').join(''))
            }
        >
            {children}
        </ToggleText>
    </div>
);

export { Group as default, Label, Toggle };
